/*
 * @Author: Alex
 * @Date: 2023-05-12 14:57:42
 * @Description:
 */
import Overlay from 'ol/Overlay'
import { ElementHelper } from '../mapUtil'
import { PanIntoViewOptions, Positioning } from 'ol/Overlay'
import { Coordinate } from 'ol/coordinate'
import { getNanoId, isArray } from '@vmap/core'
import { error } from '../console'
import { Map } from 'ol'

export interface OverlayPopupOptions {
  showCloseBox?: boolean
  offsetBox?: number | number[]
  onClose?: () => void
  onShow?: () => void
  anchor?: boolean
  minibar?: boolean
  stopEvent?: boolean
  html?: string
  popupClass?: string
  className?: string
  anim?: boolean

  autoPan?: boolean | PanIntoViewOptions
  positioning?: Positioning
  position?: Coordinate
  [k: string]: any
}

// function pickProps(props: any, propsKey: any): any {
//   return Array.isArray(propsKey)
//     ? propsKey.reduce((pickedProps: any, key) => {
//         pickedProps[key] = props[key]
//         return pickedProps
//       }, {})
//     : props[propsKey]
// }

export class OverlayPopup extends Overlay {
  private _offsetBox: number[]

  private _showCloseBox = true

  private _onclose: (() => void) | undefined

  private _onshow: (() => void) | undefined

  private _prevHTML: string | undefined | HTMLElement

  private _content: HTMLElement | undefined

  private _tout: any

  private _autoPositioning: boolean | string[] = false

  constructor(options: OverlayPopupOptions) {
    options = options || {}
    // Popup div
    const element = document.createElement('div')
    //element.classList.add('ol-overlaycontainer-stopevent');
    options.element = element

    // super(
    //   pickProps(options, [
    //     'element',
    //     'position',
    //     'offset',
    //     'positioning',
    //     'autoPan'
    //   ])
    // )

    //
    super({
      id: `popup_${getNanoId()}`,
      element: element,
      position: options.position,
      autoPan: options.autoPan,
      positioning: options.positioning
    })

    if (typeof options.offsetBox === 'number') {
      this._offsetBox = [
        options.offsetBox,
        options.offsetBox,
        options.offsetBox,
        options.offsetBox
      ]
    } else {
      this._offsetBox = options.offsetBox as number[]
    }

    // Closebox
    this._showCloseBox = options.showCloseBox ?? false
    this._onclose = options.onClose
    this._onshow = options.onShow
    ElementHelper.create('BUTTON', {
      className: 'closeBox' + (options.showCloseBox ? ' hasclosebox' : ''),
      type: 'button',
      click: () => this.hide(),
      parent: element
    })
    // Anchor div
    if (options.anchor !== false) {
      ElementHelper.create('DIV', {
        className: 'anchor',
        parent: element
      })
    }

    // Content
    this._content = ElementHelper.create('DIV', {
      html: options.html || '',
      className: 'ol-popup-content',
      parent: element
    }) as HTMLElement
    if (options.minibar) {
      ElementHelper.scrollDiv(this._content, {
        vertical: true,
        mousewheel: true,
        minibar: true
      })
    }

    // Stop event
    if (options.stopEvent) {
      element.addEventListener('mousedown', function (e) {
        e.stopPropagation()
      })
      element.addEventListener('touchstart', function (e) {
        e.stopPropagation()
      })
    }

    // this._elt = element

    // call setPositioning first in constructor so getClassPositioning is called only once
    this.setPositioning(options.positioning || 'auto')
    this.setPopupClass(options.popupClass || options.className || 'default')
    if (options.anim) this.addPopupClass('anim')

    // Show popup on timeout (for animation purposes)
    if (options.position) {
      setTimeout(() => {
        this.show(options.position)
      })
    }
  }

  /**
   * add to map
   * @param map {ol.Map}
   */
  addToMap(map: Map) {
    map.addOverlay(this)
    // this.setMap(map)
  }

  /**
   * Get CSS class of the popup according to its positioning.
   * @private
   */
  getClassPositioning() {
    let c = ''
    const pos = this.getPositioning()
    if (/bottom/.test(pos)) c += 'ol-popup-bottom '
    if (/top/.test(pos)) c += 'ol-popup-top '
    if (/left/.test(pos)) c += 'ol-popup-left '
    if (/right/.test(pos)) c += 'ol-popup-right '
    if (/^center/.test(pos)) c += 'ol-popup-middle '
    if (/center$/.test(pos)) c += 'ol-popup-center '
    return c
  }
  /**
   * Set a close box to the popup.
   * @param {bool} b
   * @api stable
   */
  setClosebox(b: boolean) {
    this._showCloseBox = b
    if (b) this.element.classList.add('hasclosebox')
    else this.element.classList.remove('hasclosebox')
  }
  /**
   * Set the CSS class of the popup.
   * @param {string} c class name.
   * @api stable
   */
  setPopupClass(cls: string) {
    const classes = ['ol-popup']
    if (this.getVisible()) classes.push('visible')
    this.element.className = ''
    const classesPositioning = this.getClassPositioning()
      .split(' ')
      .filter(function (className) {
        return className.length > 0
      })
    if (cls) {
      cls
        .split(' ')
        .filter(function (className) {
          return className.length > 0
        })
        .forEach(function (className) {
          classes.push(className)
        })
    } else {
      classes.push('default')
    }
    classesPositioning.forEach(function (className) {
      classes.push(className)
    })
    if (this._showCloseBox) {
      classes.push('hasclosebox')
    }
    classes.forEach(cls => {
      this.element.classList.add(cls)
    })
  }
  /**
   * Add a CSS class to the popup.
   * @param {string} c class name.
   * @api stable
   */
  addPopupClass(c: string) {
    this.element.classList.add(c)
  }
  /**
   * Remove a CSS class to the popup.
   * @param {string} c class name.
   * @api stable
   */
  removePopupClass(c: string) {
    this.element.classList.remove(c)
  }
  /**
   * Set positionning of the popup
   * @param {ol.OverlayPositioning | string | undefined} pos an ol.OverlayPositioning
   * 		or 'auto' to var the popup choose the best position
   * @api stable
   */
  setPositioning(pos: Positioning | string | undefined | 'auto' | 'center') {
    if (pos === undefined) return
    if (/auto/.test(pos)) {
      this._autoPositioning = pos.split('-')
      if (this._autoPositioning.length == 1) this._autoPositioning[1] = 'auto'
    } else {
      this._autoPositioning = false
    }
    pos = pos.replace(/auto/g, 'center')
    if (pos == 'center') pos = 'bottom-center'
    this.setPositioning_(pos)
  }
  /** @private
   * @param {ol.OverlayPositioning | string | undefined} pos
   */
  private setPositioning_(pos: Positioning | string | undefined) {
    if (this.element) {
      super.setPositioning(pos as Positioning)
      this.element.classList.remove(
        'ol-popup-top',
        'ol-popup-bottom',
        'ol-popup-left',
        'ol-popup-right',
        'ol-popup-center',
        'ol-popup-middle'
      )
      const classes = this.getClassPositioning()
        .split(' ')
        .filter(function (className) {
          return className.length > 0
        })
      //   this.element.classList.add.apply(this.element.classList, classes)
      classes.forEach(cls => this.element.classList.add(cls))
    }
  }
  /** Check if popup is visible
   * @return {boolean}
   */
  getVisible() {
    return this.element.classList.contains('visible')
  }
  /**
   * Set the position and the content of the popup.
   * @param {ol.Coordinate|string} coordinate the coordinate of the popup or the HTML content.
   * @param {string|undefined} html the HTML content (undefined = previous content).
   * @example
  var popup = new ol_Overlay_Popup();
  // Show popup
  popup.show([166000, 5992000], "Hello world!");
  // Move popup at coord with the same info
  popup.show([167000, 5990000]);
  // set new info
  popup.show("New informations");
  * @api stable
  */
  show(
    coordinate: Coordinate | string | undefined | boolean,
    html?: string | HTMLElement
  ) {
    if (!html && typeof coordinate == 'string') {
      html = coordinate
      coordinate = undefined
    }
    if (coordinate === true) {
      coordinate = this.getPosition()
    }

    const map = this.getMap()
    if (!map) {
      error('map cannot be null')
      return
    }

    if (html && html !== this._prevHTML && this._content) {
      // Prevent flickering effect
      this._prevHTML = html
      this._content.innerHTML = ''
      if (html instanceof Element) {
        this._content.appendChild(html)
      } else {
        ElementHelper.create('DIV', {
          html: html,
          parent: this._content
        })
      }
      if (this._content) {
        // Refresh when loaded (img)
        Array.prototype.slice
          .call(this._content.querySelectorAll('img'))
          .forEach(image => {
            image.addEventListener('load', () => {
              try {
                map.renderSync()
              } catch (e) {
                /* ok */
              }
              this._content?.dispatchEvent(new Event('scroll'))
            })
          })
      }
    }

    if (coordinate) {
      // Auto positionning
      if (this._autoPositioning) {
        const p = map.getPixelFromCoordinate(coordinate as Coordinate)
        const s = map.getSize()
        const pos = []
        if (s) {
          if (
            isArray(this._autoPositioning) &&
            this._autoPositioning[0] == 'auto'
          ) {
            pos[0] = p[1] < s[1] / 3 ? 'top' : 'bottom'
          } else {
            if (isArray(this._autoPositioning)) {
              pos[0] = this._autoPositioning[0]
            }
          }
          pos[1] = p[0] < (2 * s[0]) / 3 ? 'left' : 'right'
          this.setPositioning_(pos[0] + '-' + pos[1])
          if (this._offsetBox) {
            this.setOffset([
              this._offsetBox[pos[1] == 'left' ? 2 : 0],
              this._offsetBox[pos[0] == 'top' ? 3 : 1]
            ])
          }
        } else {
          if (this._offsetBox) {
            this.setOffset(this._offsetBox)
          }
        }
      }

      // Show
      this.setPosition(coordinate as Coordinate)
      if (this.element) {
        if (this.element.parentElement) {
          // Set visible class (wait to compute the size/position first)
          this.element.parentElement.style.display = ''
        }
        if (this._onshow) {
          this._onshow()
        }
        this.dispatchEvent('popup:show')
        this._tout = setTimeout(() => {
          this.element.classList.add('visible')
        }, 0)
      }
    }
  }
  /**
   * Hide the popup
   * @api stable
   */
  hide() {
    if (this.getPosition() == undefined) return
    if (this._onclose) {
      this._onclose()
    }
    this.setPosition(undefined)
    if (this._tout) clearTimeout(this._tout)
    this.element.classList.remove('visible')
    this.dispatchEvent('popup:hide')
  }
}
